(() => {
  const money = value => new Intl.NumberFormat('sv-SE', {style:'currency',currency:window.Shopify?.currency?.active || document.getElementById('eq-standard-config')?.dataset.currency || 'SEK',maximumFractionDigits:2}).format(value / 100);
  function init(scope) {
    scope.querySelectorAll('[data-fence-product]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      const cfg = JSON.parse(root.dataset.config);
      const variants = JSON.parse(root.querySelector('[data-fence-variants]').textContent);
      const ui = JSON.parse(root.querySelector('[data-fence-ui]').textContent);
      const form = root.querySelector('form');
      const groups = [...root.querySelectorAll('[data-option-position]')];
      const qty = root.querySelector('[data-fence-quantity]');
      const hidden = root.querySelector('[data-fence-variant]');
      const error = root.querySelector('[data-fence-error]');
      const photo = root.querySelector('[data-fence-photo]');
      const caption = root.querySelector('[data-fence-caption]');
      const quotePanel = root.querySelector('[data-fence-quote-panel]');
      const add = root.querySelector('[data-fence-add]');
      let selected;
      const choices = () => groups.map(group => group.querySelector('input:checked')?.value);
      const validQuantity = () => Number.isSafeInteger(Number(qty.value)) && Number(qty.value) >= cfg.min;
      const imageName = url => String(url || '').split('/').pop().split('?')[0];
      let photoRequest = 0;
      const thumbnails = [...root.querySelectorAll('[data-photo]')];
      const noteFor = entry => entry.overview ? ui.photoOverview : entry.generated ? ui.colorVisualization : ui.matchedPhoto;
      function setNote(note) {
        caption.textContent = note || '';
        caption.dataset.photoNoteVisible = String(!!note);
      }
      function showPhoto(url, alt, note) {
        const request = ++photoRequest;
        const imageUrl = new URL(url, location.origin);
        imageUrl.searchParams.set('width','1400');
        photo.hidden = true;
        setNote(ui.photoLoading);
        photo.onload = () => {
          if (request !== photoRequest) return;
          photo.hidden = false;
          setNote(note);
        };
        photo.onerror = () => {
          if (request !== photoRequest) return;
          photo.hidden = true;
          setNote(ui.photoUnavailable);
        };
        photo.removeAttribute('srcset');
        photo.alt = alt || root.dataset.title;
        photo.src = imageUrl.href;
        if (photo.complete && photo.naturalWidth) photo.onload();
        thumbnails.forEach(button => {
          const active = !button.hidden && imageName(button.dataset.photo) === imageName(url);
          button.classList.toggle('is-selected',active);
          button.setAttribute('aria-pressed',String(active));
        });
      }
      function draw() {
        const options = choices();
        const color = options.find(value => ['Svart','Vit','Brun'].includes(value)) || 'Svart';
        const colorLabel = root.querySelector('[data-color-label]');
        if(colorLabel) colorLabel.textContent = color;
        const lengthOption = options.find(value => /^\d+[,.]\d+ m$/.test(value));
        const install = root.querySelector('[data-fence-installation]');
        if(cfg.installationByLength){install.textContent=cfg.installationByLength[lengthOption]||'';install.hidden=!install.textContent;}
        const rails = options.find(value => /slanor/.test(value));
        const railSpecs = root.querySelector('[data-fence-rail-specs]');
        if(railSpecs){
          const specs = cfg.specsByRails?.[rails] || [];
          const list = document.createElement('ul');
          specs.forEach(spec => {const item=document.createElement('li');item.textContent=spec;list.append(item);});
          railSpecs.replaceChildren(list);
          railSpecs.hidden = specs.length === 0;
        }
        const size = options.find(value => cfg.specsBySize?.[value]);
        const specsList = root.querySelector('[data-fence-specs]');
        if (specsList && cfg.specsBySize) {
          specsList.replaceChildren(...(cfg.specsBySize[size] || cfg.specs || []).map(spec => {
            const li = document.createElement('li'); li.textContent = spec; return li;
          }));
        }
        const photoKey = cfg.kind === 'fence' ? rails+'|'+color : color;
        const match = cfg.photos?.[photoKey];
        thumbnails.forEach(button => {
          const entry = cfg.gallery?.[button.dataset.photoMediaId];
          button.hidden = cfg.gallery ? !entry?.keys.includes(photoKey) : !match || imageName(button.dataset.photo) !== imageName(match.url);
          button.classList.remove('is-selected');
          button.setAttribute('aria-pressed','false');
        });
        if(match) showPhoto(match.url,match.altText,noteFor(match));
        else {
          ++photoRequest;
          photo.hidden = true;
          photo.removeAttribute('src');
          photo.removeAttribute('srcset');
          setNote(ui.photoMissing);
        }
      }

      function update(changeVisual=false, updateUrl=false) {
        selected=variants.find(variant=>variant.options.every((value,index)=>value===choices()[index]));
        hidden.value=selected?selected.id:'';
        const valid=validQuantity();
        qty.setCustomValidity(valid?'':ui.quantityError+' '+cfg.min+' '+cfg.unit+'.');
        root.querySelector('[data-fence-price]').textContent=cfg.quoteOnly?ui.quote:selected?money(selected.price):ui.variantError;
        root.querySelector('[data-fence-total]').textContent=cfg.quoteOnly?ui.quote:selected&&valid?money(selected.price*Number(qty.value)):'—';
        if(add)add.disabled=!selected||!valid;
        error.hidden=!!selected;
        error.textContent=selected?'':ui.variantError;
        if(changeVisual)draw();
        quotePanel.hidden=true;
        if(selected&&updateUrl){const url=new URL(location.href);url.searchParams.set('variant',selected.id);history.replaceState({},'',url);}
      }
      function prepareQuote() {
        update();
        if(!selected||!form.reportValidity())return;
        const lines=[ui.quoteIntro+' '+root.dataset.title,''];
        groups.forEach((group,index)=>lines.push(group.querySelector('legend').textContent.split(':')[0]+': '+choices()[index]));
        lines.push(cfg.quantityLabel+': '+qty.value);
        const data=new FormData(form);
        for(const [name,value] of data.entries())if(name.startsWith('properties[')&&!name.startsWith('properties[_')&&name!=='properties[Enhet]'&&value)lines.push(name.slice(11,-1)+': '+value);
        if(!cfg.quoteOnly)lines.push('',ui.quoteTotal+' '+money(selected.price*Number(qty.value)));
        lines.push('',ui.quoteContact);
        const text=lines.join('\n');
        root.querySelector('[data-fence-quote-text]').value=text;
        root.querySelector('[data-fence-mail]').href='mailto:info@equistore.se?subject='+encodeURIComponent('Offertförfrågan – '+root.dataset.title)+'&body='+encodeURIComponent(text);
        quotePanel.hidden=false;
        root.querySelector('[data-fence-quote-text]').focus();
      }
      groups.forEach(group=>group.addEventListener('change',()=>update(true,true)));
      qty.addEventListener('input',()=>update());
      form.addEventListener('change',event=>{if(!event.target.closest('[data-option-position]')&&event.target!==qty)quotePanel.hidden=true;});
      form.addEventListener('submit',async event=>{
        event.preventDefault();
        update();
        if(cfg.quoteOnly){prepareQuote();return;}
        if(!selected||!validQuantity()||!form.reportValidity())return;
        add.disabled=true;
        add.setAttribute('aria-busy','true');
        try{
          const response=await fetch(root.dataset.cartUrl+'/add.js',{method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});
          const result=await response.json();
          if(!response.ok)throw Error(result.description||ui.cartError);
          location.assign(root.dataset.cartUrl);
        }catch(failure){error.textContent=ui.cartError;error.hidden=false;add.disabled=false;add.removeAttribute('aria-busy');}
      });
      root.querySelector('[data-fence-quote]').addEventListener('click',prepareQuote);
      thumbnails.forEach(button=>button.addEventListener('click',()=>{
        if(button.hidden) return;
        const entry = cfg.gallery?.[button.dataset.photoMediaId];
        const generated = button.dataset.alt?.toLowerCase().startsWith('färgvisualisering:');
        showPhoto(button.dataset.photo,button.dataset.alt,entry ? noteFor(entry) : generated ? ui.colorVisualization : ui.matchedPhoto);
      }));
      update(true);
      window.addEventListener('pageshow',()=>requestAnimationFrame(()=>update(true)));
    });
  }
  init(document);
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();


